import { QuotesIcon } from "@phosphor-icons/react";

export default function StrategicTension() {
  return (
    <section
      id="strategy"
      data-testid="strategy-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 ranq-gradient-coral" aria-hidden="true" />
      <div
        aria-hidden="true"
        className="absolute -left-32 top-1/2 -translate-y-1/2 h-[420px] w-[420px] rounded-full bg-[#ff5e3a]/30 blur-[120px]"
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <p className="text-sm uppercase tracking-[0.18em] font-semibold text-stone-700">
            Strategic tension
          </p>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl tracking-tight font-medium text-stone-900 leading-[1.1]">
            Many firms have the merit.
            <span className="block text-stone-500">
              Not all have the method to show it.
            </span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-stone-700 max-w-xl">
            Directory rankings depend on factors no firm fully controls. What
            you can control is the rigour of the document that represents your
            year of work.
          </p>
        </div>

        <div className="lg:col-span-5">
          <div className="ranq-pullquote rounded-r-2xl bg-[#f7f4ec]/80 backdrop-blur-xl border border-stone-200/80 p-8 md:p-10 shadow-sm">
            <QuotesIcon
              size={28}
              weight="fill"
              className="text-[#ff5e3a] mb-3"
            />
            <p className="font-heading text-2xl md:text-3xl font-medium text-stone-900 leading-snug">
              You can’t control the ranking. You can control the quality of
              your submission.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
